import type { Cart, CartItem } from "./schema";
import { current } from "immer";
import { v4 as uuid } from "uuid";
import { SessionActions } from "../Session/reducer";

export type CartActions =
  | { action: "updateCart"; payload: Partial<Cart> }
  | { action: "closeCart" }
  | { action: "addCartItem"; payload: CartItem }
  | { action: "removeCartItem"; payload: { cartItemId: string } }
  | { action: "updateCartItem"; payload: Partial<CartItem> & { id: string } };
// | { action: "persistPendingOrder"; payload: Order }
// | {
//     action: "updatePendingOrderItemMultiplier";
//     payload: { orderItemUuid: string; newMultiplier: number };
//   };

export const generateEmptyCart = ({ venueId }: { venueId: string }): Cart => ({
  uuid: "unsaved",
  createdAt: null,
  name: "",
  floorTableId: null,
  status: "pending",
  venueId,
  items: [],
});

const updateCart = (cart: Cart, payload: Partial<Cart>) => {
  Object.assign(cart, payload);
  return cart;
};

const addCartItem = (cart: Cart, payload: CartItem) => {
  cart.items.push(payload);
  return cart;
};

const updateCartItem = (
  cart: Cart,
  payload: Partial<CartItem> & { id: string }
) => {
  const index = cart.items.findIndex((item) => item.id == payload.id);
  if (index > -1) {
    Object.assign(cart.items[index], payload);
  }
  return cart;
};

const removeCartItem = (cart: Cart, payload: { cartItemId: string }) => {
  const index = cart.items.findIndex((item) => item.id == payload.cartItemId);
  if (index > -1) {
    cart.items.splice(index, 1);
  }
  return cart;
};
export const cartReducer = (
  cart: Cart,
  action: SessionActions
): Cart | void => {
  console.log({ cart, action });
  switch (action.action) {
    case "updateCart":
      updateCart(cart, action.payload);
      break;
    case "addCartItem":
      addCartItem(cart, action.payload);
      break;
    case "updateCartItem":
      updateCartItem(cart, action.payload);
      break;
    case "removeCartItem":
      removeCartItem(cart, action.payload);
      break;
    default:
      return cart;
  }
};
